import {addPutMethodToForm, post} from '../utils'

export default host => id =>
    post(`${host}/musics/${id}/approve`, addPutMethodToForm(new FormData()))
        .then(response => response.json())
